/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import styled from "styled-components";
import blueGrey from "@material-ui/core/colors/blueGrey";

import Button from "@material-ui/core/Button";

const StyledButton = styled(Button)`
  background-color: ${blueGrey[50]} !important;
  position: absolute !important;
  margin-left: auto !important;
  margin-right: auto !important;
  left: 0;
  right: 0;
  bottom: 0;
`;

export default function StickyButton(props) {
  return <StyledButton variant="contained" size="large" {...props} />;
}
